<template>
  <header class="page-search">
    <div class="page-search-title">
      <h1 class="page-title" v-text="title"></h1>
    </div>
    <div class="page-search-form">
      <vue-simple-suggest
        ref="suggest"
        v-model="query"
        :debounce="300"
        :list="list"
        value-attribute="guid"
        @input="onInput"
        @select="onSuggestSelect">
        <input v-model="text" type="text" placeholder="Поиск" class="form-control search-input" @keyup.enter="search">

        <div slot="suggestion-item" slot-scope="{ suggestion, query }">
          <div class="item-title">{{ suggestion.type === 'training-center' ?  suggestion.description : suggestion.title  }}</div>
          <div v-if="suggestion.type" class="category">{{ typeMap[suggestion.type] }}</div>
        </div>
      </vue-simple-suggest>
      <button type="submit" class="btn btn-search" @click="search">Найти</button>
    </div>
  </header>
</template>

<script>
import VueSimpleSuggest from "vue-simple-suggest";
import { typeMap, searchMixin } from "@/utils/helpers";

export default {
  name: "PageSearch",
  components: { VueSimpleSuggest },
  mixins: [searchMixin],
  props: {
    title: String
  },
  data: () => ({
    query: "",
    text: "",
    list: [],
    typeMap
  }),
  watch: {
    async $route() {
      if (!Object.keys(this.$route.query).length) {
        this.text = "";
      }
    }
  }
};
</script>
<style lang="scss">
.page-search {
  display: flex;
  justify-content: space-between;
  min-height: unset;
  align-items: center;
}

.page-title {
  color: #000000;
}

.page-search-form {
  display: flex;
  width: 50%;
  position: relative;
  .vue-simple-suggest {
    flex: 4;
    margin-right: -5px;
    border-radius: 5px;

    &.designed {
      .input-wrapper {
        min-height: unset;
        @include media-breakpoint-down(sm) {
          min-height: unset;
        }
        input {
          height: 58px;
          padding-left: 30px;
          border-radius: 5px;
          border: 1px solid #e5e5e5;

          &::placeholder {
            color: #adadad;
          }

          @include media-breakpoint-down(sm) {
            padding: 4px 20px;
            height: 45px;
            font-size: 14px;
          }
        }
      }

      .suggestions {
        @include media-breakpoint-down(sm) {
          width: calc(100vw - 58px);
        }
      }
    }
  }

  .search-input {
    flex: 3;
    margin-right: -5px;
    border-radius: 5px;

    &::placeholder {
      color: #adadad;
    }
  }

  .btn-search {
    width: 128px;
    z-index: 9;
  }
}
@include media-breakpoint-only(md) {
  .page-search-form {
    width: 54%;
    margin-top: 20px;
  }
}
@include media-breakpoint-down(sm) {
  .page-search {
    flex-wrap: wrap;

    .btn-search {
      width: auto;
      z-index: 9;
      font-weight: 500;
    }
  }

  .page-search-form {
    width: 100%;
    margin-top: 20px;
  }
}
</style>
